import { Table } from '@chakra-ui/react';
import React, { useState } from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import { IColumn } from '@/types';

interface IProps<T> {
  columns: IColumn<T>[];
  item: T;
  index: number;
  renderExpand: (item: T, expanded: boolean) => React.ReactNode;
  disableRowClickExpand?: boolean;
  handleGoDetail?: (item: T) => void;
  colSpan: number;
}

export function RowExpand<T>(props: IProps<T>) {
  const [expanded, setExpanded] = useState<boolean>(false);

  const handleToggle = (event: any) => {
    event.stopPropagation();
    setExpanded((prev) => !prev);
  };

  return (
    <React.Fragment>
      <Table.Row
        onClick={
          props.disableRowClickExpand ? () => props.handleGoDetail?.(props.item) : handleToggle
        }
        cursor={props.disableRowClickExpand && !props.handleGoDetail ? undefined : 'pointer'}
        style={{ width: '100%' }}
      >
        <Table.Cell className="cell-expand" onClick={handleToggle} cursor="pointer" width="60px">
          <div className="btn-expand">{expanded ? <FaCaretUp /> : <FaCaretDown />}</div>
        </Table.Cell>
        {props.columns.map((col, index) => {
          const align = col.align ? col.align : index == 0 ? 'left' : 'center';
          return (
            <Table.Cell
              key={col.key as string}
              className={align === 'center' ? 'text-center' : 'text-left'}
              width={col.width}
            >
              {col.render ? col.render(props.item, props.index) : ''}
            </Table.Cell>
          );
        })}
      </Table.Row>
      {/* {expanded && props.renderExpand(props.item)} */}
      <Table.Row className={`expandable-row ${expanded ? 'expanded' : ''}`}>
        <Table.Cell
          colSpan={props.colSpan}
          className="expand-content"
          style={{
            borderBottom: expanded ? 'inherit' : 'none',
          }}
        >
          <div className="expand-wrapper">{props.renderExpand(props.item, expanded)}</div>
        </Table.Cell>
      </Table.Row>
    </React.Fragment>
  );
}
